import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, H2 } from "@components/Typography";
import { Routes } from "@ctypes";
import { useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { useNavigate, useLocation } from "react-router-dom";
import { styles } from "./styles";
import { SuccessIcon } from "./SuccessIcon";

export const WithdrawalSuccessModal = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { dismiss } = useModal();

  const route = location.pathname as Routes;

  const onClick = () => {
    dismiss();
    if (route === Routes.Withdraw) {
      navigate(-1);
    }
  };

  const props: OverlayProps = {
    cta: {
      primary: {
        title: i18n.t(Translations.WithdrawalSuccessModalPrimaryCTA),
        onClick,
      },
    },
  };

  return (
    <Overlay {...props}>
      <SuccessIcon style={styles.icon} />
      <Spacing size={SpacingSizes.M} />

      <H2 style={styles.text}>{i18n.t(Translations.WithdrawalSuccessModalTitle)}</H2>
      <Spacing size={SpacingSizes.M} />

      <Body style={styles.text}>{i18n.t(Translations.WithdrawalSuccessModalSubtitle)}</Body>
      <Spacing size={SpacingSizes.M} />
    </Overlay>
  );
};
